import colors from 'src/theme/colors';
import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';
import Input from './Input';

const triggerStyle = defineStyle({
  '--stepper-base-radius': '10px',
  bg: 'podcastShade100',
  _hover: {
    bg: 'podcastShade200',
  },
  _active: {
    bg: 'podcastShade300',
  },
});

const NumberInput = defineSlotRecipe({
  slots: ['root', 'input', 'control', 'incrementTrigger', 'decrementTrigger', 'valueText'],
  base: {
    input: {
      ...Input.base,
      verticalAlign: 'top',
    },
    root: {
      outlineOffset: 0,
      _hover: {
        boxShadow: 'none',
      },
      _focusWithin: {
        borderColor: 'podcastPurple',
        outlineWidth: '1px',
        outlineStyle: 'solid',
        outlineColor: 'podcastPurple',
        _invalid: {
          borderColor: 'podcastRed400',
          outlineWidth: '1px',
          outlineColor: 'podcastRed400',
        },
      },
      _invalid: {
        border: `1px solid ${colors.podcastRed}`,
        boxShadow: 'inset 0px -3px 6px rgba(239, 57, 113, 0.05)',
      },
    },
    incrementTrigger: triggerStyle,
    decrementTrigger: triggerStyle,
  },
  variants: {
    size: {
      small: {
        input: {
          height: '36px',
          fontSize: '13px',
        },
        control: {
          height: '36px',
          fontSize: '13px',
        },
      },
      large: {
        input: {
          height: '48px',
          padding: '20px',
          fontSize: '16px',
        },
        control: {
          height: 'calc(100% - 2px)',
          fontSize: '16px',
          '--stepper-width': '32px',
        },
      },
    },
  },
  defaultVariants: {
    size: 'large',
  },
});

export default NumberInput;
